import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RefreshIcon from '@mui/icons-material/Refresh';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import {
  TextInput, useNotify, useRecordContext, useRefresh,
} from 'react-admin';

import { authHttpClient } from '@/Auth/authProvider';
import TidalIcon from '@/icons/TidalIcon.svg';

function AlbumTidalSection() {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  const handleForceRefresh = async () => {
    if (!record?.DiscographyAlbumIdentifier) {
      notify('No album ID found', { type: 'error' });
      return;
    }

    setLoading(true);
    try {
      const url = `/api/admin/discography/albums/${record.DiscographyAlbumIdentifier}/sync-Tidal`;

      await authHttpClient(url, {
        method: 'POST',
      });

      notify('Tidal sync completed successfully', { type: 'success' });
      refresh();
    } catch (error) {
      console.error('Error syncing with Tidal:', error);
      notify('Failed to sync with Tidal', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenTidal = () => {
    if (!record?.TidalAlbumId) {
      notify('No Tidal URL available', { type: 'warning' });
      return;
    }
    window.open(record.TidalAlbumId, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      mb={3} width={{ xs: '100%', md: '70%' }}
      p={2} border={1}
      borderRadius={2} borderColor='grey.400'
    >
      <Typography
        variant='h6' gutterBottom
        display='flex' alignItems='center'
        gap={1}
      >
        <img
          src={TidalIcon}
          alt='Tidal'
          style={{ width: 24, height: 24 }}
        />
        Tidal
      </Typography>

      <Box
        display='flex' gap={3}
        alignItems='center'
      >
        <Box flex={1}>
          <Box mb={2}>
            <TextInput
              source='TidalAlbumId' label='Tidal URL'
              fullWidth
            />
          </Box>

          <Box
            mt={2} display='flex'
            gap={2} flexWrap='wrap'
          >
            <Button
              variant='contained'
              color='primary'
              startIcon={<RefreshIcon />}
              onClick={handleForceRefresh}
              disabled
            >
              {loading ? 'Syncing...' : 'Force Refresh'}
            </Button>

            <Button
              variant='outlined'
              color='primary'
              startIcon={<OpenInNewIcon />}
              onClick={handleOpenTidal}
              disabled={!record?.TidalAlbumId}
            >
              Open on Tidal
            </Button>
          </Box>
        </Box>

      </Box>
    </Box>
  );
}

export default AlbumTidalSection;
